import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AppStateProvider } from 'src/app/providers/app-state.provider';
import { APIs } from 'src/app/config/api.constant';
import { ApiService } from 'src/app/services/api.service';
import { AppConstant } from 'src/app/config/app.constant';


export class EmailTemplate {
  fromId: string;
  toId: string;
  subject: string;
  body: string;
}

@Component({
  standalone: false,
  selector: 'app-bulk-upload-employees',
  templateUrl: './bulk-upload-employees.component.html',
  styleUrls: ['./bulk-upload-employees.component.scss'],
})
export class BulkUploadEmployeesComponent implements OnInit {
  meetingNav: { index: string; name: string; link: string }[];
  uploadFile: any;
  fileName: any;
  EXCEL_EXTENSION = '.xlsx';
  EXCEL_TYPE ='application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
  sheet: any = [];
  url: string;
  templateUrl: string;
  formData: FormData = new FormData();
  apiResult: any = [];
  bulkUploadInputStep:boolean = true;
  bulkUploadProcessStep:boolean = false;
  bulkUploadResultStep:boolean = false;
  members: any = [];
  successCount:number;
  failuresCount:number;
  bulkUploadSuccessMsg:boolean = false;
  bulkUploadUnSuccessMsg = false;
  isValidEmployee:boolean = true;
  uploadSuccessful:boolean = false;

  constructor(private router: Router, private appStateSrv: AppStateProvider, 
    private apiService: ApiService) {}

  ngOnInit(): void {
    this.meetingNav = [
      {
        index: '1',
        name: 'Employees',
        link: '/employees/employees-list/bulk-upload-employees',
      },
    ];

    const route = {
      index: '1',
      name: 'Employees',
      link: '/employees/employees-list/bulk-upload-employees',
    };
    this.appStateSrv.setSideNavState(route);

    this.getTemplateUrl();
  }

  handleFileSelect(evt) {
    this.formData = new FormData();
    var files = evt.target.files; // FileList object
    this.uploadFile= files[0];
    this.fileName = files[0].name;
    this.formData.append('excelFile', this.uploadFile, this.fileName);
    this.bulkEmployeesUpload();
  } 

  viewEmployeeList() {
    this.router.navigate(['/employees/employees-list']);
  }

  getTemplateUrl() {
    if (localStorage.getItem(AppConstant.localStorage.token) != null) {
      this.url = APIs.getBulkEmployeesUploadTemplate;
      this.apiService.get(this.url, '').subscribe(
        (response: any) => {
          this.templateUrl = response.data;
          console.log('test', this.templateUrl)
        },
        err => console.log('error', err)
      );
    }
  }

  bulkEmployeesUpload() {
    if (localStorage.getItem(AppConstant.localStorage.token) != null) {
     
      let tenantId: string = localStorage.getItem(AppConstant.localStorage.tenantId)
      this.url = APIs.bulkEmployeesUpload + '?tenantId=' +  tenantId;
      this.apiService.post(this.url, this.formData).subscribe(
        (response: any) => {
          this.apiResult = response;
          this.bulkUploadInputStep = false;
          this.bulkUploadProcessStep = true;
          this.bulkUploadResultStep = false;
          this.members = this.apiResult.data.users;
          this.successCount = this.apiResult.data.successCount;
          this.failuresCount = this.apiResult.data.failuresCount;
          //this.isValidEmployee = this.apiResult.data.isValidEmployee;
          
          if (this.apiResult.isValid)
          {
            this.bulkUploadSuccessMsg = true;
            this.bulkUploadUnSuccessMsg = false;
          }
          else
          {
            this.bulkUploadUnSuccessMsg = true;
            this.bulkUploadSuccessMsg = false;
          }
        },
        err => console.log('error', err) 
      );
    }
  }

  sendInvitation(evt) {
    // let fromEmailId:string;
    // this.adminSrv.getAdminData().pipe(details => {
    //     fromEmailId = details.adminEmailId;
    // });

    // let temp = new EmailTemplate();
    // temp.fromId = fromEmailId;
    // temp.subject = "";
    // temp.body = this.body;
    // temp.toId = '';
    const data: string[] = [];
     this.members.forEach((member) => {
      data.push(member.emailId);
    });
    this.url = APIs.sendEmailsToMember;
      this.apiService.post(this.url, data).subscribe(
        (response: any) => {
          if (response.isValid)
          {
            this.uploadSuccessful = true;
            this.bulkUploadInputStep = true;
            this.bulkUploadProcessStep = false;
            this.bulkUploadResultStep = true;
          }
        });
  } 
  
  getRowCssClass(isValidRow, isEven, isOdd)
  {
    if(isValidRow == false)
    {
      return "error-row";
    }
    else
    {
        if (isEven)
        {
          return "even";
        }
        else
        {
          return "Odd";
        }
    }
  }
}
